var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useRef } from 'react';
import { Button, GBTypography } from '@leapfinance/geebee-component-library';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { ACCEPTABLE_FILE_UPLOAD_TYPES, DOCUMENT_ACTION_TYPES } from '../../constants/common';
var DocumentCard = function (_a) {
    var title = _a.title, titleClassName = _a.titleClassName, subTitle = _a.subTitle, subTitleClassName = _a.subTitleClassName, documentMeta = _a.documentMeta, _b = _a.displayActions, displayActions = _b === void 0 ? [DOCUMENT_ACTION_TYPES.DOWNLOAD, DOCUMENT_ACTION_TYPES.UPLOAD] : _b, _c = _a.disabledActions, disabledActions = _c === void 0 ? [] : _c, _d = _a.className, className = _d === void 0 ? 'lfc-w-[15rem]' : _d, _e = _a.maxFileUploadSizeAllowedInMB, maxFileUploadSizeAllowedInMB = _e === void 0 ? 35 : _e, onUpload = _a.onUpload, onFileUploadWarning = _a.onFileUploadWarning, onDownload = _a.onDownload;
    var fileUploadRef = useRef(null);
    var handleFileUploadFromLocal = function (event) {
        var files = event.target.files;
        if (!files)
            return;
        var file = files[0];
        if ((file === null || file === void 0 ? void 0 : file.size) > maxFileUploadSizeAllowedInMB * 1000000) {
            onFileUploadWarning === null || onFileUploadWarning === void 0 ? void 0 : onFileUploadWarning();
            event.target.value = '';
            return;
        }
        onUpload === null || onUpload === void 0 ? void 0 : onUpload(__assign(__assign({}, documentMeta), { file: file }));
    };
    var handleUpload = function () {
        var _a;
        (_a = fileUploadRef === null || fileUploadRef === void 0 ? void 0 : fileUploadRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    var handleDownload = function () {
        onDownload === null || onDownload === void 0 ? void 0 : onDownload(documentMeta);
    };
    return (React.createElement("div", { className: "lfc-px-3 lfc-py-4 lfc-rounded-lg lfc-border lfc-border-[#736EFF] lfc-bg-white ".concat(className) },
        React.createElement("input", { type: 'file', ref: fileUploadRef, className: "lfc-hidden", onChange: handleFileUploadFromLocal, accept: ACCEPTABLE_FILE_UPLOAD_TYPES }),
        React.createElement("div", { className: titleClassName || " lfc-ml-2 ".concat(subTitle ? 'lfc-mb-2' : 'lfc-mb-6') },
            React.createElement(GBTypography, { variant: "sh2Semibold" }, title)),
        subTitle ? (React.createElement("div", { className: subTitleClassName || ' lfc-ml-2 lfc-text-[#E79F4C] lfc-mb-4' },
            React.createElement(GBTypography, { variant: "caption1" }, subTitle))) : null,
        React.createElement("div", { className: "lfc-flex lfc-items-center" },
            displayActions.includes(DOCUMENT_ACTION_TYPES.UPLOAD) ? (React.createElement(Button, { variant: "tertiary", onClick: handleUpload, className: "lfc-text-gbTokens-primary-500 lfc-normal-case", endIcon: React.createElement(FileUploadOutlinedIcon, { fontSize: "small" }), disabled: disabledActions.includes(DOCUMENT_ACTION_TYPES.UPLOAD) }, "Upload")) : null,
            displayActions.includes(DOCUMENT_ACTION_TYPES.DOWNLOAD) ? (React.createElement(Button, { variant: "tertiary", onClick: handleDownload, className: ' lfc-font-medium lfc-text-sm', endIcon: React.createElement(FileDownloadOutlinedIcon, { fontSize: "small" }), disabled: disabledActions.includes(DOCUMENT_ACTION_TYPES.DOWNLOAD) }, "Download")) : null)));
};
export default DocumentCard;
//# sourceMappingURL=DocumentCard.js.map